export enum SHIPPING_METHODS {
  STANDARD = 'standard',
  PREMIUM = 'premium'
}
